import { useFilter } from "hooks/filter";
import { MoodBoard } from "types/qbank/moodboard";
import { SearchModelEnum } from "types/qbank/searchModel";


export default function MoodBoardItem(props: {
    moodboard: MoodBoard;
    close: () => void;
}) {
    const {
        moodboard,
        close,
    } = props;
    const { searchDispatch } = useFilter();

    const selectMoodboard = (moodboard: MoodBoard) => {
        searchDispatch({
            type: "ADD_FILTER",
            payload: {
                value: moodboard.id,
                text: moodboard.name,
                label: "Moodboard",
                criteria: SearchModelEnum.moodboardIds,
            },
        });
        close();
    };

    return (
        <>
            <div
                key={moodboard.id}
                className={"menu-body-item moodboard-svg"}
                onClick={() => selectMoodboard(moodboard)}>
                <div className="moodboard-svg-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1.59277 18.398V1.63672H18.4003V18.398H1.59277ZM0.0927734 1.23672C0.0927734 0.629205 0.58526 0.136719 1.19277 0.136719H18.8003C19.4078 0.136719 19.9003 0.629206 19.9003 1.23672V18.798C19.9003 19.4056 19.4078 19.898 18.8003 19.898H1.19278C0.585262 19.898 0.0927734 19.4056 0.0927734 18.798V1.23672ZM8.4966 4.19102H4.13042V8.50166H8.4966V4.19102ZM4.13042 2.69102H2.63042V4.19102V8.50166V10.0017H4.13042H8.4966H9.9966V8.50166V4.19102V2.69102H8.4966H4.13042ZM15.9219 11.5602H11.5557V15.8708H15.9219V11.5602ZM11.5557 10.0602H10.0557V11.5602V15.8708V17.3708H11.5557H15.9219H17.4219V15.8708V11.5602V10.0602H15.9219H11.5557Z"
                            fill="black"
                        />
                    </svg>
                </div>
                <div className={"moodboard-item-name"}>
                    {moodboard.name}
                </div>
            </div>
        </>
    );
}